<template>
  <div class="pageContent">
    <div class="ltgk-box wide clearfix">
      <div class="ltgk">
        <p>新县概况</p>
        <div class="describe ltgk-information">
          地理位置新县位于北纬31°28'～31°46'，东经114°33'～115°12'之间。处河南省南端,大别山腹地，鄂豫皖三省六县结合部。东与商城县接壤，南、西面分别与湖北省麻城市、红安县、大悟县及本省罗山县毗邻，北与光山县缘连。京九铁路、312国道和正在建设的大(大庆)广(广州)高速公路穿境而过，东距合肥240公里，南距武汉160公里，北距郑州390公里，素有“三省通衢”、“中原南门”之称，跨长江、淮河两大流域，境域东西长61.6公里，南北宽40.7公里。水文气候新县属亚热带北部大陆性季风气候，具有亚热带过渡性特征，四季分明。
        </div>
        <div class="see">
          <a href="javascript:;" @click="goDetail('新县概况','新县概况')">查看详情</a>
        </div>
      </div>
      <div class="gkimg">
        <img
          src="@/assets/images/xxgk.png"
          alt=""
        />
      </div>
    </div>

    <div class="bgCo">
      <div class="lt-box wide">
        <p class="term-name">历史文化</p>
        <a href="javascript:void(0)">
          <div @click="goList('探索新县','历史文化')" class="more">更多&gt;&gt;</div>
        </a>

        <div class="history">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, i) in history" :key="i">
              <div class="his" @click="goDetail('历史文化', item.pubTittle, item.id)">
                <img class="his_img"   :src="imgURl + 'xxszxc/' + item.slt"/>
                <p class="his_name">{{ item.bt }}</p>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>

    <div class="lt-box wide">
      <p class="term-name">图说新县</p>
      <a href="javascript:void(0)">
        <div @click="goList('探索新县','图说新县')" class="more">更多&gt;&gt;</div>
      </a>
      <div class="lty-box flex-container-bet">
        <div
          class="lty-img t-hover-shadow"
          @click="goDetail('图说新县', item.bt, item.id)"
          v-for="(item, i) in ltys"
          :key="i"
        >
          <a href="javascript:void(0)">
            <img
              :src="imgURl + 'xxszxc/' + item.slt"
              alt=""
            />
            <div class="lty-name">{{ item.bt }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
const imgURl = API_IMG_URL;

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      imgURl: imgURl,
      history: [],
      ltys: [],
      swiperOption: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  methods: {
    goDetail(type, title, id) {
      this.$router.push({
        path: 'detail',
        query: {
          type,
          title,
          id
        },
      })
    },
    goList(meunname,type) {
      this.$router.push({
        path: "/list",
        query: {
          meunname:meunname,
          type: type,
        },
      });
    },

    async getDataList() {
      // 21-历史文化,22-图说新县
      try {
        let res1 = await this.$http.queryPageList({currentPage: 1, pubType: 21,pageSize: 7} );
        let res2 = await this.$http.queryPageList( {currentPage: 1, pubType: 22,pageSize: 4} );
        this.history = res1.response.records;
        this.ltys = res2.response.records;
      } catch (error) {
        console.log(error);
      }
    },

  },
  mounted() {
    this.getDataList();
  },
}
</script>

<style lang="less" scoped>
.pageContent {
  .ltgk a,
  .jt-more a {
    padding: 5px 20px;
    border: 1px solid #ccc;
    border-radius: 25px;
    cursor: pointer;
  }
  a {
    color: #000;
    text-decoration: none;
  }
  .wide {
    width: 1200px;
    margin: 0 auto;
  }
  .clearfix {
    display: block;
    clear: both;
    content: '';
    overflow: hidden;
  }
  .ltgk-box {
    position: relative;
    padding: 15px;
    .ltgk {
      width: 560px;
      padding: 0 20px;
      float: left;
      p {
        padding: 15px 0;
        text-align: center;
        font-size: 32px;
        color: #02d4d5;
      }
      .ltgk-information {
        height: 250px;
      }
      .describe {
        color: #4b4b4b;
        text-indent: 2em;
        line-height: 30px;
      }
      .see {
        text-align: center;
      }
    }
    .gkimg {
      width: 50%;
      float: right;
      img {
        width: 100%;
        height: 360px;
        vertical-align: top;
      }
    }
  }

  .bgCo {
    padding-bottom: 10px;
    .lt-box {
      position: relative;
      a {
        color: #000;
        text-decoration: none;
        .more {
          position: absolute;
          right: 20px;
          top: 64px;
          cursor: pointer;
          color: #02d4d5;
        }
      }
      p {
        text-align: center;
      }
      .term-name {
        padding: 40px 0 20px 0;
        font-size: 34px;
      }

      .history {
        .swiper-container {
          position: relative;
          width: 100%;
          height: 360px;
          .swiper-slide {
            color: #000;
            font-size: 16px;
            text-align: center;
            .his {
              cursor: pointer;
              .his_img {
                width: 230px;
                height: 300px;
              }
              .his_name {
                font-size: 16px;
                margin-top: 10px;
                text-align: center;
                color: #4b4b4b;
                cursor: pointer;
                &:hover {
                  color: #fea004;
                }
              }
            }
          }
        }
      }
    }
    .wide {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .lt-box {
    position: relative;
    .term-name {
      padding: 40px 0 20px 0;
      font-size: 34px;
    }
    a {
      .more {
        position: absolute;
        right: 20px;
        top: 64px;
        cursor: pointer;
        color: #02d4d5;
      }
    }
    p {
      text-align: center;
    }
    .lty-box {
      
      padding-bottom: 15px;
      .lty-img {
        margin-right: 10px;
        margin-bottom: 10px;
        img {
          width: 290px;
          height: 180px;
          cursor: pointer;
          vertical-align: top;
        }
      }
      .lty-img {
        margin-right: 10px;
        margin-bottom: 10px;
        img {
          vertical-align: top;
        }
        .lty-name {
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #4b4b4b;
          border-left: 1px solid #dedede;
          border-right: 1px solid #dedede;
          border-bottom: 1px solid #dedede;
          cursor: pointer;
        }
      }
      .t-hover-shadow {
        transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
        &:hover {
          box-shadow: 0 10px 50px rgba(51, 51, 51, 0.5);
          transform: translateY(-10px);
        }
      }
    }
    .flex-container-bet {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
